"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Accordion_1 = require("./Accordion");
const { root } = Accordion_1.accordionDetailsClasses;
const MuiAccordionDetailsOverrides = {
    MuiAccordionDetails: {
        styleOverrides: {
            root: ({ theme }) => ({ [`&.${root}`]: { backgroundColor: theme.palette.common.white } }),
        },
    },
};
exports.default = MuiAccordionDetailsOverrides;
//# sourceMappingURL=AccordionDetailsOverride.js.map